import React from 'react';
import { styled, Swiper, LazyImage } from '@teko/ui';
import { getTrackingData } from '@teko/tracking';
import { PreLoad } from '../PreLoad/PreLoad.es.js';
import { CustomLink } from '../CustomLink/CustomLink.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = styled.div`
  border-radius: 0.5rem;
  overflow: hidden;
`;
const MiniSlides = (_a) => {
  var _b = _a, {
    banners = [],
    isLoading = false,
    regionName,
    height = 140,
    width = 1232
  } = _b, props = __objRest(_b, [
    "banners",
    "isLoading",
    "regionName",
    "height",
    "width"
  ]);
  if (isLoading)
    return /* @__PURE__ */ React.createElement(PreLoad, {
      height,
      isLoading
    });
  if (!isLoading && !banners.length)
    return null;
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Swiper, {
    autoplay: {
      delay: 2500
    },
    slidesPerView: 1,
    loop: true,
    hasNavigation: true
  }, banners.map((banner, index) => {
    return /* @__PURE__ */ React.createElement("div", __spreadValues({
      key: index,
      className: "swiper-slide"
    }, getTrackingData({
      isTrackContent: true,
      regionName: regionName || "topBanner",
      contentName: banner.campaignName,
      target: banner.targetPath,
      index
    })), /* @__PURE__ */ React.createElement(CustomLink, {
      targetPath: banner.targetPath
    }, /* @__PURE__ */ React.createElement(LazyImage, {
      borderRadius: 8,
      height,
      src: banner.image,
      alt: banner.campaignName,
      width,
      imageWidth: width,
      hover: "zoom",
      cover: true
    })));
  })));
};

export { MiniSlides };
